import { Button } from "@mui/material";

export default function GoHomeButton({ onNavigateHome, label = "Go Home" }) {
  return (
    <Button variant="contained" onClick={onNavigateHome} sx={{ width: { xs: "100%", sm: "auto" } }}>
      {label}
    </Button>
  );
}
